import { useRawAPI } from 'hooks/useApi';
import { AppDispatch, RootState } from 'store';
import { Country } from 'types';
// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';

export function loadCurrencies() {
    return (dispatch: AppDispatch, getState: RootState) => {
        //@ts-ignore
        let state = getState();
        dispatch({ type: 'CURRENCIES_LOAD' });
        if (!state.currencies || state.currencies.length == 0) {
            let api = useRawAPI();
            return api
                .get('/clients-dashboard/trading/balance-transactions-currencies')
                .then((response) => {
                    let currencies: string[] = response?.data?.data || ['USD', 'GBP'];
                    dispatch(currenciesLoaded(currencies.filter((item) => item != 'n/a')));
                })
                .catch((error) => {
                    console.error('Error while loading currencies. ', error);
                    dispatch(currenciesLoaded(['USD', 'GBP']));
                });
        }
    };
}
export function currenciesLoaded(currencies: string[]) {
    return { type: 'CURRENCIES_LOAD_DONE', payload: currencies };
}

export function loadCountries() {
    return (dispatch: AppDispatch, getState: RootState) => {
        //@ts-ignore
        let state = getState();
        dispatch({ type: 'COUNTRIES_LOAD' });
        if (!state.countries || state.countries.length == 0) {
            let api = useRawAPI();
            return api
                .get('/countries/all')
                .then((response) => {
                    let countries: Country[] = response?.data?.countries || [];
                    dispatch(countriesLoaded(countries));
                })
                .catch((error) => {
                    console.error('Error while loading countries. ', error);
                    dispatch(countriesLoaded([]));
                });
        }
    };
}
export function countriesLoaded(countries: Country[]) {
    return { type: 'COUNTRIES_LOAD_DONE', payload: countries };
}
